/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsListScheduleRuns } from "../../funcs/llmEvalsListScheduleRuns.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListEvalScheduleRunsRequest$inboundSchema,
};

export const tool$llmEvalsListScheduleRuns: ToolDefinition<typeof args> = {
  name: "llm-evals-list-schedule-runs",
  description: `List runs created by an eval schedule

Returns eval runs that were created by the given schedule. suite_version may be used without suite_id here, since the schedule already pins the suite; supplying a suite_id that is not the schedule's returns 400.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsListScheduleRuns(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
